<template>
<div class="view-content">
	  <div class="view-content-info">
		<div class="user-login">
		  	<div class="user-login-title"><a href="/">首页</a> / <span>搜索结果</span></div>
			
			
			<div v-if="show == 'recommend'" class="no-data" style="padding: 100px 0px;margin-bottom: 20px;">
				<img src="@/assets/images/no.png"/>
				<div class="no-title">抱歉，没有搜索到与 <span>{{name}}</span> 相关的商品</div>
				<div class="no-msg">请检查您的输入是否有误</div>
				<div class="no-msg">您还可以尝试以下搜索:</div>
				<div class="flex-midden flex-center flex-wrap hot-list">
					<div v-for="item in hotList" :key="item.id" @click="toSeach(item.name)">{{item.name}}</div>
				</div>
			</div>
			<div class="goods-list flex-start flex-wrap" v-if="newGoods.length > 0">
				<goods-item v-for="item in newGoods" :info="item" :key="item.id"></goods-item>
			</div>
			
			
			<div class="page" v-if="total > 0">
			    <el-pagination @current-change="getPageList" :current-page="page" :page-size="limit" layout="total, prev, pager, next" :total="total"></el-pagination>
			</div>
		</div>
	  </div>
	</div>
</template>

<script>
import goodsItem from '@/components/goodsItem.vue'
import {getGoodslist, hotKeywords} from "@/api/index"
export default {
	name: 'index',
	components:{
		goodsItem
	},
	data(){
		return {
			newGoods:[],
			page:1,
			limit:16,
			total:0,
			isLoad:false,
			name:"",
			hotList:[],
			show:"list"
		}
	},
	
	watch: {
		// 直接使用$route来监听路由变化
		'$route.query': function (newQuery, oldQuery) {
			this.name = newQuery.name || "";
			this.isLoad = false;
			this.page = 1;
			this.getList();
		}
	},
	mounted() {
		this.name = this.$route.query.name || "";
		this.isLoad = false;
		this.getList();
		//获取热门搜索词
		hotKeywords().then(res=>{
			this.hotList = res.data;
		})
	},
	methods:{
		getList(){
			getGoodslist({condition:{name:this.name},page:this.page,size:this.limit}).then(res=>{
				if(res.code == 1000){
					this.newGoods = res.data.list;
					this.total = res.data.total;
					this.isLoad = true;
					if(this.page == 1 && res.data.list.length == 0){
						this.show = "recommend";
						this.getRecommendList();
					}else{
						this.show = "list";
					}
				}else{
					return this.$message.error(res.message);
				}
			})
		},
		getRecommendList(){
			getGoodslist({condition:{indexStatus:0},page:this.page,size:this.limit}).then(res=>{
				if(res.code == 1000){
					this.newGoods = res.data.list;
					this.total = res.data.total;
					this.isLoad = true;
				}else{
					return this.$message.error(res.message);
				}
			})
		},
		getPageList(e){
			this.isLoad = false;
			this.page = e;
			if(this.show == "list"){
				this.getList();
			}else{
				this.getRecommendList();
			}
		},
		toSeach(name){
			this.$router.push("/search?name="+name);
		}
	}
}
</script>

<style lang="scss" scoped>
	.no-data{
		width: 100%;
		padding: calc(50vh - 300px) 0px;
		background: #FFFFFF;
		text-align: center;
		img{
			width: 120px;
			height: 120px;
		}
		.no-title{
			font-size: 16px;
			font-weight: 500;
			color: #9E9E9E;
			margin-top: 12px;
			span{
				color: #E91A12;
			}
		}
		.no-msg{
			font-size: 16px;
			color: #9E9E9E;
			margin-top: 12px;
			margin-bottom: 32px;
		}
		.hot-list{
			div{
				height: 28px;
				border: 1px solid rgba(233, 26, 18, 0.3);
				font-size: 14px;
				color: #E91A12;
				padding: 0px 24px;
				line-height: 28px;
				text-align: center;
				margin: 6px;
				cursor: pointer;
			}
		}
	}
	.goods-list{
		min-height: calc(100vh - 600px);
	}
	.cate{
		width: 1320px;
		background: #FFFFFF;
		padding: 8px 40px;
		margin-bottom: 20px;
		box-sizing: border-box;
		.cate-title{
			height: 22px;
			font-size: 16px;
			line-height: 22px;
			color: #070B13;
			margin: 8px 0px;
			opacity: 0.4;
			flex: 0 0 60px;
		}
		.cate-right{
			div{
				height: 22px;
				border-radius: 4px;
				padding: 0px 8px;
				font-size: 32rpx;
				line-height: 22px;
				text-align: center;
				color: #070B13;
				margin: 8px 25px 8px 0px;
				cursor: pointer;
			}
			.active{
				color: #fff;
				background: #E91A12;
			}
		}
	}
</style>
